/**
 * ObjectFieldSet React component
 * 
 * @author    Maurizio Tidei
 * @copyright © 2018 contexagon GmbH
 */


// React
import React from 'react';
import PropTypes from 'prop-types';

// Material-UI
import {withStyles} from "@material-ui/core";
import ObjectField from "./ObjectField";


/**
 * ObjectFieldSet is a React component combining multiple object fields
 *
 * @author Maurizio Tidei
 */
export class ObjectFieldSet extends React.Component {

    render() {

        const objectFields = this.props.objectFields || {};

        return <div className={this.props.classes.fieldContainer}>
            {this.props.fieldDefinitions.map(
                fieldDef => <ObjectField
                    objectId={this.props.objectId}
                    key={fieldDef.id}
                    fieldDef={fieldDef}
                    scope={this.props.scope}
                    value={objectFields[fieldDef.id]}
                    suffix={objectFields[fieldDef.id + "__suffix"]}
                    readOnly={this.props.readOnly && !fieldDef.transient}
                    onObjectValueChange={this.props.onObjectValueChange}
                />
            )}
        </div>;
    }
}

const styles = theme => ({
    fieldContainer: {
        "width": "100%"
    }
});

ObjectFieldSet.propTypes = {
    fieldDefinitions: PropTypes.array.isRequired,
    objectId: PropTypes.string,
    objectFields: PropTypes.object,
    readOnly: PropTypes.bool,
    scope: PropTypes.arrayOf(PropTypes.string),
    onObjectValueChange: PropTypes.func.isRequired
};

export default withStyles(styles)(ObjectFieldSet);